import * as React from "react"
import { useTracker } from "@modules/analytics"
import ToggleCheckbox from "@modules/ui/components/ToggleCheckbox"
import { useToggleBuilds } from "../hooks/useToggleBuilds"
import { siteBuildsSettings as siteBuildsSettingsText } from "@modules/locales/default.json"

export type EnableBuildsProps = {
  siteId: string
  buildsEnabled: boolean
}

export function EnableBuilds({ siteId, buildsEnabled }: EnableBuildsProps) {
  const [toggleBuilds, { errorAlert }] = useToggleBuilds(siteId)
  const { trackButtonClicked } = useTracker()

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-builds-checkbox"
        label={siteBuildsSettingsText.labels.enableBuilds}
        checked={!!buildsEnabled}
        onChange={() => {
          trackButtonClicked(`update incremental builds`, {
            uiSource: `Site Settings`,
          })

          toggleBuilds()
        }}
      />
      {errorAlert}
    </React.Fragment>
  )
}
